import * as R from "ramda";
import Layout from "./Layout";
import { withRouter } from "react-router";
import { createContext } from "redux-mvc";
import module from "Portal/NewPortal/FollowupForm";
import { actions } from "Portal/NewPortal/FollowupForm/model";

const decorate = createContext({
  module,
  options: {
    observedDomains: [
      "user",
      "event",
      "permissions",
      "organization",
      "portal",
      "records",
      "submission",
      "Data",
      "activities",
      "@flopflip"
    ],
    persist: false
  },
  lifeCycle: {
    constructor() {
      this.showAlert = true;
    },
    componentDidMount() {
      window.addEventListener("beforeunload", this.handlers.onUnload);
      if (this.props.route.name === "followupFormCallback") {
        this.showAlert = false;
        this.store.dispatch(actions.handleCallback(this.props.location.query));
      } else {
        this.store.dispatch(
          actions.init({
            ...this.props.params,
            ...this.props.location.query,
            returnTo: this.props.location.query.returnTo
          })
        );
      }

      // scroll to top of page
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    componentWillUnmount() {
      window.removeEventListener("beforeunload", this.handlers.onUnload);
    }
  },
  handlers: {
    setShowAlert(value) {
      this.showAlert = value;
    },
    onUnload(e) {
      if (this.showAlert) {
        const confirmationMessage =
          "Are you sure you want to leave your submission?";
        (e || window.event).returnValue = confirmationMessage; // Gecko + IE
        return confirmationMessage; // Gecko + Webkit, Safari, Chrome etc.
      }
      return undefined;
    }
  }
});

export default R.compose(withRouter, decorate)(Layout);
